import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import { changeOdometer, selectVehicleById } from '../../features/assets/assetsSlice';

const ChangeOdometerModal = ({ changeOdometerOpen, handleChangeOdometerClose, assetId }) => {
    const dispatch = useDispatch();
    const assetData = useSelector(state => selectVehicleById(state, assetId));
    const initialOdo = (assetData && Math.ceil(assetData.coreData.odometer)) || -1;
    const regn = assetData && assetData.vehicleDevice.regn;

    const [odometer, setOdometer] = useState(initialOdo);
    const [odoDate, setOdoDate] = useState(moment().format('YYYY-MM-DDTHH:mm'));

    useEffect(() => {
        setOdometer(initialOdo);
    }, [assetId, initialOdo]);

    const handleSubmit = () => {
        dispatch(changeOdometer({
            assetId, odometer, odoDate
        }));
        handleChangeOdometerClose();
    }

    useEffect(() => {
        if (changeOdometerOpen) {
            // When modal opens, set current date/time
            setOdoDate(moment().format('YYYY-MM-DDTHH:mm'));
        }
    }, [changeOdometerOpen]);

    useEffect(() => {
        if (!changeOdometerOpen) {
            // Reset state when modal closes
            setOdoDate(moment().format('YYYY-MM-DDTHH:mm'));
        }
    }, [changeOdometerOpen]);

    return (
        <Dialog open={changeOdometerOpen} onClose={handleChangeOdometerClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title"><b>Change Odometer: {regn}</b></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter the Odometer reading taken from the vehicle. If the reading was taken more than 5 minutes ago, please set the reading date correctly as well.
                </DialogContentText>
                <form>
                    <TextField
                        variant="standard"
                        autoFocus
                        id="name"
                        label="Odometer Reading"
                        type="number"
                        value={odometer}
                        onChange={(e) => setOdometer(e.target.value)}
                    />
                    <br />
                    <br />
                    <Typography variant="body1">Reading Date & Time</Typography>
                    <TextField
                        variant="standard"
                        id="datetime-local"
                        type="datetime-local"
                        value={odoDate}
                        onChange={(e) => setOdoDate(e.target.value)}
                    />
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleChangeOdometerClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary">
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ChangeOdometerModal;